import { NgModule } from "@angular/core";
import { LorenAutomationPlansRoutingModule } from "./loren-automation-plans-routing.module";
import { LorenAllAutomationPlansResolver } from "./resolvers/loren-all-automation-plans.resolver";
import { LorenAutomationPlanResolver } from "./resolvers/loren-automation-plan.resolver";
import { LorenPlanTimePeriodConverterPipe } from "./pipes/loren-plan-time-period-converter-pipe/loren-plan-time-period-converter.pipe";

@NgModule({
  declarations: [],
  providers: [
    LorenAllAutomationPlansResolver,
    LorenAutomationPlanResolver,
    LorenPlanTimePeriodConverterPipe,
  ],
  imports: [LorenAutomationPlansRoutingModule],
})
export class LorenAutomationPlansModule {}
